export default "__VITE_ASSET__BKSM120e__"